var filters = ( function( $ ) {

	var $filters;
	var $search_inputs;
	var $search_inputs_wide_screen;
	var $clear_single;
	var $clear_all_of_term;

	var _init = function() {

		$search_inputs = $( '.filter-search-input' );
		$search_inputs_wide_screen = $search_inputs.not( '.responsive' );
		$filters = $( '.crate-filters' );
		$clear_single = $( '.clear-single' );
		$clear_all_of_term = $( '.clear' );

		if ( $search_inputs.length > 0 ) {

			for ( let i = 0; i < $search_inputs.length; i++ ) {
				$( $search_inputs[ i ] ).select2( {
					placeholder: 'Type ' + $( $search_inputs[ i ] ).attr( 'data-term' ) + ' to browse events'
				} );
			}
			$search_inputs_wide_screen.next().addClass( 'hidden' ); //need to set hidden in JS after the select2 is initialised.
			$search_inputs.on( 'change', _handle_select2_select );
		}

		if ( $clear_single ) {
			$clear_single.on( 'click', _handle_clear_single );
		}

	};

	var _handle_select2_select = function( e ) {
		$( ".select2-selection__choice" ).addClass( "blue-select2-choice" );
		_update_submission_url();
	};

	var _update_submission_url = function( to_remove = false ) {

		var data = {
			"profession": [],
			"keyword": [],
			"location": [],
			"organiser": [],
			"type": []
		};

		var $filter_dropdowns = $( '.filter-dropdown' );

		//already in
		for ( let i = 0; i < $filter_dropdowns.length / 2; i++ ) {

			var $filter_dropdown = $( $filter_dropdowns[ i ] );

			var key = $filter_dropdown.attr( 'data-key' );
			var id = $filter_dropdown.attr( 'data-id' );

			data[ key ].push( id );
		}

		//added by searching
		for ( let i = 0; i < $search_inputs.length; i++ ) {
			var $search_input = $( $search_inputs[ i ] );
			var select2_data = $search_input.select2( 'data' );

			var key = $search_input.attr( 'data-term' );

			for ( let i = 0; i < select2_data.length; i++ ) {
				data[ key ].push( select2_data[ i ].id );
			}
		}

		if ( to_remove ) {
			var index = data[ to_remove.key ].indexOf( to_remove.id );
			data[ to_remove.key ].splice( index, 1 );
		}

		var url = $filters.data( 'base-url' );
		var begun_query_string = false;

		Object.keys( data ).forEach( function( key ) {
			if ( data[ key ].length > 0 ) {
				if ( begun_query_string ) {
					url += '&';
				} else {
					begun_query_string = true;
					url += '?';
				}

				url += `${ key }=`;

				for ( let i = 0; i < data[ key ].length; i++ ) {
					url += data[ key ][ i ];
					if ( i != data[ key ].length - 1 ) {
						url += ',';
					}
				}
			}
		} );

		$filters.find( '.apply-filters' ).attr( 'href', url );

		return url;

	};

	var _handle_clear_single = function( e ) {
		e.preventDefault();

		$parent = $( e.currentTarget ).parent();
		$id = $parent.attr( 'data-id' );
		$key = $parent.attr( 'data-key' );

		var url = _update_submission_url( { key: $key, id: $id } );
		window.location.href = url;
	};

	if ( $( '.event-filters ' ).length > 0 ) {
		_init();
	}

	return {};

} )( jQuery );

module.exports = filters;